function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 255.994,
  r: 81.619,
  fill: "#f0f0f0"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 255.994,
  r: 66.783,
  fill: "#6da544"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 256,
  cy: 255.994,
  r: 44.522,
  fill: "#f0f0f0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#0052b4",
  d: "M256 244.864l-24.116 11.13v18.55L256 289.386l24.116-14.842v-18.55z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M231.88 233.734h48.228v22.261H231.88z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M0 85.331h512v29.68H0zm0 311.653h512v29.682H0z",
  fill: "#a2001d"
});

const SvgBelize = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBelize, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/belize.c0d2cb48.svg";
export { ForwardRef as ReactComponent };